export default __webpack_public_path__ + "static/media/codethink.753f2580.svg";